import React from 'react';
import { DisplayConfiguration } from '@carvana/showroom-tooltip/Base/Content';
import {
  OverviewContainer,
  OverviewRow,
  OverviewLabel,
  OverviewValue,
  OverviewValueBalance,
  TooltipContent,
  OverviewRowContainer,
  OverviewValueContainer,
  ProgressBarContainer,
} from './LoanOverview.styles';
import { formatCurrency } from '../../../../utils/CurrencyUtils';
import InfoToolTip from '../../../future-packages/info-tooltip';
import ProgressBar from '../../../future-packages/progress-bar';
import { ProgressBarColors } from '../../../../constants';

const LoanOverview = ({ loanOverviewData }: any) => {
  const { currentLoanBalance, principalPaid, isPastDue } = loanOverviewData;

  const totalLoanAmount = currentLoanBalance + principalPaid;

  // Principal Paid / Total Loan Amount) * 100
  const paidOffPercentage = (principalPaid / totalLoanAmount) * 100;
  const langPack = {
    title: 'Overview',
    paid: 'Principal Paid',
    balance: 'Remaining Principal',
  };

  const tooltipConfig: Partial<DisplayConfiguration> = {
    width: 300,
    height: 135,
    arrowOffsetX: -19,
    contentOffsetX: 30,
  };

  const tooltipContent = () => (
    <>
      <h3>Principal Paid</h3>
      <TooltipContent>
        Payment progress is approximate and based on principal only. Interest
        and fees are not reflected. This is not a payoff quote. Contact
        Bridgecrest for payoff information.
      </TooltipContent>
    </>
  );

  return (
    <OverviewContainer>
      <OverviewRowContainer>
        <OverviewRow>
          <OverviewLabel>{langPack.paid}</OverviewLabel>
          <OverviewValueContainer>
            <OverviewValue isPastDue={isPastDue}>
              {formatCurrency(loanOverviewData.principalPaid)}
            </OverviewValue>
            <InfoToolTip
              display={tooltipConfig}
              content={tooltipContent}
              trackEventContent="principal_paid_tooltip_tap"
            />
          </OverviewValueContainer>
        </OverviewRow>
        <OverviewRow>
          <OverviewLabel>{langPack.balance}</OverviewLabel>
          <OverviewValueBalance>
            {formatCurrency(currentLoanBalance)}
          </OverviewValueBalance>
        </OverviewRow>
      </OverviewRowContainer>
      <ProgressBarContainer>
        {isPastDue && (
          <ProgressBar
            ratio={paidOffPercentage}
            label="Paid"
            foregroundColor={ProgressBarColors.pastDue.foregroundColor}
            backgroundFontColor={ProgressBarColors.pastDue.backgroundFontColor}
          />
        )}
        {!isPastDue && <ProgressBar ratio={paidOffPercentage} label="Paid" />}
      </ProgressBarContainer>
    </OverviewContainer>
  );
};

export default LoanOverview;
